import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface OtherLiabilitiesRommsProps {
  onBack?: () => void;
}

export default function OtherLiabilitiesRomms({ onBack }: OtherLiabilitiesRommsProps) {
  return <PayrollRomms onBack={onBack || (() => {})} onComplete={() => {}} workspace="Other Liabilities" />;
}
